import React from "react";
import fronend from "../Material/react.png";
import backend from "../Material/back.png";
import data from "../Material/data.png";
import "./Prof.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Profiency = () => {
  AOS.init();
  return (
    <div className="ProfConatinerM">
      <h1>Proficiency</h1>
      <div
        data-aos="flip-up"
        data-aos-offset="30"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        className="ProfConatiner"
      >
        <div>
          <img src={fronend} alt="fronend" />
          <h5>Front end</h5>
        </div>
        <div>
          <img src={backend} alt="backend" />
          <h5>Back end</h5>
        </div>
        <div>
          <img src={data} alt="data" />
          <h5>DSA</h5>
        </div>
      </div>
    </div>
  );
};

export default Profiency;
